import { useEffect } from "react";
import { useI18n } from "@/hooks/use-i18n";
import { HeaderBar } from "@/components/HeaderBar";
import { LegalLayout } from "@/components/LegalLayout";
import { Footer } from "@/components/Footer";

export default function CookiePolicy() {
  const { t, tArray, dir, lang, setLang } = useI18n();

  useEffect(() => {
    document.title = `${t("legal.cookies.title")} - Aurelian Private Care`;
  }, [t, lang]);

  const sectionKeys = ["technical", "noTracking", "analytics", "management"] as const;
  const sections: Record<string, { title: string; items: string[] }> = {};
  for (const key of sectionKeys) {
    sections[key] = {
      title: t(`legal.cookies.sections.${key}.title`),
      items: tArray(`legal.cookies.sections.${key}.items`),
    };
  }

  return (
    <div className="flex flex-col min-h-screen" dir={dir}>
      <HeaderBar lang={lang} onChangeLang={setLang} dir={dir} />
      <LegalLayout
        title={t("legal.cookies.title")}
        intro={t("legal.cookies.intro")}
        lastUpdated={t("legal.lastUpdated")}
        backLabel={t("legal.backToHome")}
        sections={sections}
        dir={dir}
      />
      <Footer t={t} dir={dir} />
    </div>
  );
}
